import React, { useEffect, useState } from 'react';
import Item from '../../components/Form/Item';
import { Checkbox, Row, Col, message } from 'antd';
import { ErrorMessage, useFormikContext } from 'formik';
import axios from '../../util/Api';
import { LoadingOutlined } from '@ant-design/icons';

const SicknessForm = (props) => {
  const formik = useFormikContext();
  const [loading, setLoading] = useState(true);
  const [sickness, setSickness] = useState({});

  useEffect(() => {
    fetchSkills();
  }, []);

  const fetchSkills = () => {
    setLoading(true);
    const url = `/sickness/list`;
    axios.get(url).then(({ data }) => {
      setSickness(data);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat daftar riwayat kesehatan");
    });
  }

  const handleChange = (values) => {
    formik.setFieldValue("sickness", values);
  }

  return (
    <Item name="Riwayat Kesehatan">
      <Checkbox.Group style={{width: "100%"}} defaultValue={formik.values.sickness} onChange={handleChange}>
        {loading ? (
          <>
            <LoadingOutlined className="gx-mr-2" /> Sedang memuat daftar riwayat kesehatan
          </>
        ) : (
          <Row>
            <Col span={24}>
              <h5>Sakit yang diderita saat ini</h5>  
            </Col>
            {sickness.map((item, key)=>{
              return (
                <Col md={12} xs={24} key={`sickness-${key}`}>
                  <div className="gx-mb-1">
                    <Checkbox value={item.id}>{item.name}</Checkbox>
                  </div>
                </Col>
              );
            })}
          </Row>
        )}
      </Checkbox.Group>
      <ErrorMessage component="div" name="sickness" className="gx-mt-2 gx-text-red" />
    </Item>
  );
}

export default SicknessForm;